<!-- Loading do contrato -->
<div *ngIf="carregandoContrato" class="form-card">
  <div class="card-content">
    <div class="estado-inline">
      <i class="pi pi-spinner pi-spin"></i>
      <span>{{ 'contador_operar.despesa_acessoria.carregando' | translate }}</span>
    </div>
  </div>
</div>

<!-- Erro ao carregar o contrato -->
<div *ngIf="!carregandoContrato && erroContrato" class="form-card">
  <div class="card-content">
    <div class="estado-vazio">
      <i class="pi pi-exclamation-triangle estado-erro-icon"></i>
      <p>{{ 'contador_operar.despesa_acessoria.erro_contrato' | translate }}</p>
      <button pButton
        [label]="'contador.dashboard.estados.tentar_novamente' | translate"
        icon="pi pi-refresh"
        class="btn-primary btn-sm"
        (click)="carregarContrato()">
      </button>
    </div>
  </div>
</div>

<!-- Sem contrato ativo com o cliente -->
<div *ngIf="!carregandoContrato && !erroContrato && !contrato" class="form-card">
  <div class="card-content">
    <div class="estado-vazio">
      <i class="pi pi-file-excel"></i>
      <p>{{ 'contador_operar.despesa_acessoria.sem_contrato_ativo' | translate }}</p>
    </div>
  </div>
</div>

<!-- =================================================================== -->
<!-- Contrato ativo: card do contrato + formulário + lista de despesas    -->
<!-- =================================================================== -->
<ng-container *ngIf="!carregandoContrato && !erroContrato && contrato">

  <!-- =============== Card: Contrato ativo (componente compartilhado) =============== -->
  <app-contrato-info-card *ngIf="modo !== 'gastos'"
    [contrato]="contratoInfoVM"
    [moedaConfig]="moedaConfig"
    [mesReferenciaEditavel]="true"
    [mesReferenciaOptions]="mesReferenciaOptions"
    [(mesReferenciaValor)]="contratoMesReferencia"
    [mesReferenciaSalvando]="salvandoMesReferencia"
    (mesReferenciaChange)="onMesReferenciaContratoChange($event)"
    [valorMensalEditavel]="true"
    [valorMensalSalvando]="salvandoValorMensal"
    (valorMensalChange)="onValorMensalChange($event)"
    [diaCobrancaEditavel]="true"
    [diaCobrancaSalvando]="salvandoDiaCobranca"
    (diaCobrancaChange)="onDiaCobrancaChange($event)"
    [parcelasPorMesEditavel]="true"
    [parcelasPorMesSalvando]="salvandoParcelasPorMes"
    (parcelasPorMesChange)="onParcelasPorMesChange($event)"
    [mostrarCancelar]="true"
    (cancelar)="abrirCancelarContrato()">
  </app-contrato-info-card>

  <!-- =============== Card: Parcelas do contrato (componente compartilhado) =============== -->
  <app-parcelas-contrato *ngIf="modo !== 'gastos'"
    [parcelas]="parcelas"
    [carregando]="carregandoParcelas"
    [erro]="erroParcelas"
    [totalParcelasContrato]="contratoTotalParcelas"
    [sortField]="parcelasSortField"
    [sortOrder]="parcelasSortOrder"
    (sortChange)="onParcelasSort($event)"
    [first]="parcelasFirst"
    [rows]="parcelasRows"
    [totalRecords]="parcelasTotalRecords"
    [pageSizeOptions]="pageSizeOptions"
    (pageChange)="onParcelasPageChange($event)"
    (rowsChange)="parcelasRows = $event; onParcelasRowsPerPageChange()"
    [periodoValorPadrao]="'showAll'"
    (periodoChange)="onParcelasPeriodoChanged($event)"
    [situacao]="parcelasSituacao"
    [situacaoOptions]="parcelasSituacaoOptions"
    (situacaoChange)="onParcelasSituacaoChangeValor($event)"
    (recarregar)="carregarParcelas()"
    [mostrarAcoesContador]="true"
    [mostrarSaldo]="false"
    [(selecionadas)]="parcelasSelecionadas"
    [faturaveis]="parcelasFaturaveis"
    [excluiveis]="parcelasExcluiveis"
    [processandoFaturamento]="processandoFaturamento"
    [excluindoParcelas]="excluindoParcelas"
    (adicionar)="abrirAdicionarParcelas()"
    (faturar)="faturarParcelas()"
    (excluir)="excluirParcelasLote()"
    (abrirNota)="abrirNota($event)">
  </app-parcelas-contrato>

  <!-- =============== Abas: Novo gasto x Gastos lançados =============== -->
  <!-- Tab bar minimalista (sublinhado na ativa), replicando o padrao visual da
       tela de Produtos/Artigos. Nao usamos p-tabView aninhado para nao herdar o
       estilo do p-tabView do componente pai (operar-cliente). -->
  <div class="tabs-container" *ngIf="modo !== 'contrato'">
    <nav class="aba-nav" role="tablist">
      <button *ngFor="let opt of abaOpcoes"
              type="button"
              role="tab"
              class="aba-link"
              [class.aba-ativa]="abaAtiva === opt.value"
              [attr.aria-selected]="abaAtiva === opt.value"
              (click)="abaAtiva = opt.value">
        <i class="pi tab-icon" [ngClass]="opt.value === 'form' ? 'pi-plus-circle' : 'pi-list'"></i>
        <span>{{ opt.label }}</span>
      </button>
    </nav>
  </div>

  <!-- =============== Aba: Adicionar / Editar despesa =============== -->
  <form *ngIf="modo !== 'contrato' && abaAtiva === 'form'" (ngSubmit)="submit()" class="form-card">
    <div class="card-header">
      <div class="card-header-icon">
        <i class="pi" [ngClass]="editando ? 'pi-pencil' : 'pi-plus-circle'"></i>
      </div>
      <span class="card-header-title">
        {{ (editando
            ? 'contador_operar.despesa_acessoria.titulo_editar'
            : 'contador_operar.despesa_acessoria.titulo_adicionar') | translate }}
      </span>
    </div>
    <div class="card-content">
      <div class="config-grid">
        <!-- Valor -->
        <div class="form-item">
          <label>{{ 'contador_operar.despesa_acessoria.valor' | translate }} <span class="obrigatorio">*</span></label>
          <!-- Sem mode="currency": no PrimeNG 17 esse modo trava a digitacao quando a
               moeda tem 0 casas decimais (Guarani/PYG) — so aceita 1 digito. Usamos o
               modo decimal com [locale]/[useGrouping] e min/maxFractionDigits derivados
               da moeda do contrato (0 p/ Guarani, 2 p/ demais). Mesmo padrao adotado em
               produto-selecionar para o bug do PYG. -->
          <p-inputNumber
            [(ngModel)]="form.valor"
            name="valor"
            [prefix]="prefixoMoeda"
            [currency]="moedaConfig.symbol"
            [locale]="moedaConfig.locale"
            [minFractionDigits]="fracDigits"
            [maxFractionDigits]="fracDigits"
            [useGrouping]="true"
            [min]="0"
            styleClass="w-full"
            inputStyleClass="w-full"
            [class.error-field]="submetido && (form.valor == null || form.valor <= 0)">
          </p-inputNumber>
        </div>

        <!-- Data de pagamento -->
        <div class="form-item">
          <label>{{ 'contador_operar.despesa_acessoria.data_pagamento' | translate }} <span class="obrigatorio">*</span></label>
          <p-calendar
            [(ngModel)]="form.dataPagamento"
            name="dataPagamento"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            appendTo="body"
            styleClass="w-full"
            inputStyleClass="w-full"
            [class.error-field]="submetido && !form.dataPagamento">
          </p-calendar>
        </div>


        <!-- Tipo de despesa -->
        <div class="form-item">
          <label>{{ 'contador_operar.despesa_acessoria.tipo' | translate }} <span class="obrigatorio">*</span></label>
          <p-dropdown
            [options]="tipoDespesaOptions"
            [(ngModel)]="form.tipoDespesa"
            name="tipoDespesa"
            optionLabel="nome"
            optionValue="enum"
            [filter]="true"
            [showClear]="true"
            appendTo="body"
            styleClass="w-full"
            [placeholder]="'contador_operar.despesa_acessoria.tipo_placeholder' | translate"
            [class.error-field]="submetido && !form.tipoDespesa">
            <!-- Icone + cor vem do backend no proprio item (/enums/tipoDespesa).
                 Mesmo padrao visual de Nova despesa: circulo colorido + icone branco. -->
            <ng-template let-item pTemplate="item">
              <div class="flex align-items-center gap-2">
                <div *ngIf="item.icone || item.cor" class="flex align-items-center justify-content-center border-circle"
                  [ngStyle]="{ width: '28px', height: '28px', 'min-width': '28px', background: item.cor || '#eceff4' }">
                  <i class="{{ item.icone || 'pi pi-briefcase' }}" style="color: #fff; font-size: 0.75rem;"></i>
                </div>
                <span>{{ item.nome }}</span>
              </div>
            </ng-template>
            <ng-template let-item pTemplate="selectedItem">
              <div class="flex align-items-center gap-2" *ngIf="item">
                <div *ngIf="item.icone || item.cor" class="flex align-items-center justify-content-center border-circle"
                  [ngStyle]="{ width: '22px', height: '22px', 'min-width': '22px', background: item.cor || '#eceff4' }">
                  <i class="{{ item.icone || 'pi pi-briefcase' }}" style="color: #fff; font-size: 0.6rem;"></i>
                </div>
                <span>{{ item.nome }}</span>
              </div>
            </ng-template>
          </p-dropdown>
        </div>

        <!-- Forma de pagamento (conta do contador) — só quando NÃO especial -->
        <div class="form-item" *ngIf="!form.especial">
          <label>{{ 'contador_operar.despesa_acessoria.forma_pagamento' | translate }} <span class="obrigatorio">*</span></label>
          <p-dropdown
            [options]="formaPagamentoOptions"
            [(ngModel)]="form.contaId"
            name="contaId"
            optionLabel="label"
            optionValue="value"
            [filter]="true"
            [showClear]="true"
            appendTo="body"
            styleClass="w-full"
            [placeholder]="'contador_operar.despesa_acessoria.forma_pagamento_placeholder' | translate"
            [class.error-field]="submetido && !form.especial && form.contaId == null">
          </p-dropdown>
        </div>
      </div>

      <!-- Despesa especial -->
      <div class="form-item form-item-checkbox">
        <!-- Em despesa ja ATIVA a forma de cobranca e travada: muda-la criaria/removeria
             titulo e movimento, e o backend recusa (422). -->
        <p-checkbox
          [(ngModel)]="form.especial"
          name="especial"
          [binary]="true"
          inputId="despesaEspecial"
          [disabled]="editandoAtiva"
          (onChange)="onEspecialChange()">
        </p-checkbox>
        <label for="despesaEspecial" class="checkbox-label">
          {{ 'contador_operar.despesa_acessoria.especial' | translate }}
        </label>
      </div>
      <small class="form-ajuda">{{ 'contador_operar.despesa_acessoria.especial_ajuda' | translate }}</small>

      <!-- Aviso: a despesa nasce pendente e aguarda a aprovação do cliente -->
      <div class="form-aviso" *ngIf="!editandoAtiva">
        <i class="pi pi-info-circle"></i>
        <span>{{ 'contador_operar.despesa_acessoria.aviso_pendente' | translate }}</span>
      </div>

      <!-- Editando despesa já efetivada: a alteração mexe no que o cliente deve. A ressalva do
           ajuste manual do caixa só aparece quando o backend NÃO ajusta sozinho — despesa
           especial (sem adiantamento) ou anterior à V1.106 (sem vínculo com o movimento). -->
      <div class="cancelar-aviso-futuro" *ngIf="editandoAtiva">
        <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
        <span>
          {{ 'contador_operar.despesa_acessoria.aviso_ativa_edicao' | translate }}
          <ng-container *ngIf="!form.especial && editandoAtivaSemAjusteDeCaixa">
            {{ 'contador_operar.despesa_acessoria.aviso_ativa_movimento' | translate }}
          </ng-container>
        </span>
      </div>

      <!-- Ações -->
      <div class="config-acoes">
        <button *ngIf="editando" pButton type="button"
          class="p-button-secondary"
          [label]="'contador_operar.despesa_acessoria.cancelar' | translate"
          [disabled]="salvando"
          (click)="cancelarEdicao()">
        </button>
        <button pButton type="submit"
          icon="pi pi-check"
          [label]="(editando
              ? 'contador_operar.despesa_acessoria.editar'
              : 'contador_operar.despesa_acessoria.salvar') | translate"
          class="btn-primary"
          [loading]="salvando"
          [disabled]="salvando">
        </button>
      </div>
    </div>
  </form>

  <!-- =============== Aba: Lista de despesas =============== -->
  <div *ngIf="modo !== 'contrato' && abaAtiva === 'lista'" class="form-card table-card">
    <div class="card-header">
      <div class="card-header-icon table-icon">
        <i class="pi pi-list"></i>
      </div>
      <span class="card-header-title">{{ 'contador_operar.despesa_acessoria.lista_titulo' | translate }}</span>
      <!-- Filtros compactos (periodo por data de pagamento + tipo + situacao +
           cobranca) e o botao "Novo gasto", agrupados a direita do cabecalho. -->
      <div class="despesas-header-acoes">
        <app-periodo-filtro
          class="filtro-compacto filtro-periodo"
          modo="avancado"
          [persistir]="false"
          [valorPadrao]="'showAll'"
          styleClass="w-full"
          [pTooltip]="'contador_operar.despesa_acessoria.filtros.periodo' | translate"
          tooltipPosition="top"
          (periodoChanged)="onDespesasPeriodoChanged($event)">
        </app-periodo-filtro>
        <p-dropdown
          class="filtro-compacto"
          [options]="despesasTipoOptions"
          optionLabel="label"
          optionValue="value"
          [(ngModel)]="despesasTipo"
          (onChange)="onDespesasFiltroChange()"
          [pTooltip]="'contador_operar.despesa_acessoria.filtros.tipo' | translate"
          tooltipPosition="top"
          appendTo="body"
          styleClass="w-full">
          <!-- Mesmo circulo colorido do formulario. A opcao "Todos" nao tem
               cor/icone, entao aparece so com o texto. -->
          <ng-template let-item pTemplate="item">
            <div class="flex align-items-center gap-2">
              <div *ngIf="item.icone || item.cor" class="flex align-items-center justify-content-center border-circle"
                [ngStyle]="{ width: '28px', height: '28px', 'min-width': '28px', background: item.cor || '#eceff4' }">
                <i class="{{ item.icone || 'pi pi-briefcase' }}" style="color: #fff; font-size: 0.75rem;"></i>
              </div>
              <span>{{ item.label }}</span>
            </div>
          </ng-template>
          <ng-template let-item pTemplate="selectedItem">
            <div class="flex align-items-center gap-2" *ngIf="item">
              <div *ngIf="item.icone || item.cor" class="flex align-items-center justify-content-center border-circle"
                [ngStyle]="{ width: '22px', height: '22px', 'min-width': '22px', background: item.cor || '#eceff4' }">
                <i class="{{ item.icone || 'pi pi-briefcase' }}" style="color: #fff; font-size: 0.6rem;"></i>
              </div>
              <span class="white-space-nowrap overflow-hidden text-overflow-ellipsis">{{ item.label }}</span>
            </div>
          </ng-template>
        </p-dropdown>
        <p-dropdown
          class="filtro-compacto"
          [options]="despesasStatusOptions"
          optionLabel="label"
          optionValue="value"
          [(ngModel)]="despesasStatus"
          (onChange)="onDespesasFiltroChange()"
          [pTooltip]="'contador_operar.despesa_acessoria.filtros.situacao' | translate"
          tooltipPosition="top"
          appendTo="body"
          styleClass="w-full">
        </p-dropdown>
        <p-dropdown
          class="filtro-compacto"
          [options]="despesasCobrancaOptions"
          optionLabel="label"
          optionValue="value"
          [(ngModel)]="despesasCobranca"
          (onChange)="onDespesasFiltroChange()"
          [pTooltip]="'contador_operar.despesa_acessoria.filtros.cobranca' | translate"
          tooltipPosition="top"
          appendTo="body"
          styleClass="w-full">
        </p-dropdown>
        <button pButton
          [label]="'contador_operar.despesa_acessoria.aba_novo' | translate"
          icon="pi pi-plus"
          (click)="novoGasto()"
          class="p-button-secondary btn-novo-gasto">
        </button>
      </div>
    </div>
    <div class="card-content">
      <!-- Erro da lista -->
      <div *ngIf="!carregandoDespesas && erroDespesas" class="estado-vazio">
        <i class="pi pi-exclamation-triangle estado-erro-icon"></i>
        <p>{{ 'contador_operar.despesa_acessoria.erro_lista' | translate }}</p>
        <button pButton
          [label]="'contador.dashboard.estados.tentar_novamente' | translate"
          icon="pi pi-refresh"
          class="btn-primary btn-sm"
          (click)="carregarDespesas()">
        </button>
      </div>

      <!-- Tabela (paginacao + ordenacao SERVER-SIDE + paginador separado no
           rodape, mesmo padrao da tela de Indicacoes/cupons). -->
      <ng-container *ngIf="!erroDespesas">
      <p-table
        [value]="despesas"
        [loading]="carregandoDespesas"
        [customSort]="true"
        (onSort)="onSort($event)"
        [sortField]="sortField"
        [sortOrder]="sortOrder"
        dataKey="id"
        styleClass="p-datatable-sm">

        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="valor">
              {{ 'contador_operar.despesa_acessoria.col_valor' | translate }}<p-sortIcon [field]="'valor'"></p-sortIcon>
            </th>
            <th pSortableColumn="dataPagamento">
              {{ 'contador_operar.despesa_acessoria.col_data' | translate }}<p-sortIcon [field]="'dataPagamento'"></p-sortIcon>
            </th>
            <th pSortableColumn="tipoDespesa">
              {{ 'contador_operar.despesa_acessoria.col_tipo' | translate }}<p-sortIcon [field]="'tipoDespesa'"></p-sortIcon>
            </th>
            <!-- Sem pSortableColumn: `especial` nao esta na whitelist de sort do backend
                 (aceita valor, dataPagamento, tipoDespesa e status) — ver o service. -->
            <th class="text-center">{{ 'contador_operar.despesa_acessoria.col_especial' | translate }}</th>
            <th pSortableColumn="status">
              {{ 'contador_operar.despesa_acessoria.col_status' | translate }}<p-sortIcon [field]="'status'"></p-sortIcon>
            </th>
            <th>{{ 'contador_operar.despesa_acessoria.col_pagamento' | translate }}</th>
            <th class="col-acoes">{{ 'contador_operar.despesa_acessoria.col_acoes' | translate }}</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-despesa>
          <!-- A linha abre os titulos do cliente em contas a receber; a coluna de
               acoes para o clique, para editar/excluir nao navegarem junto. -->
          <tr [class.linha-clicavel]="temTitulosParaAbrir(despesa)"
              [attr.tabindex]="temTitulosParaAbrir(despesa) ? 0 : null"
              [pTooltip]="temTitulosParaAbrir(despesa)
                ? ('contador_operar.despesa_acessoria.abrir_titulos' | translate)
                : ''"
              tooltipPosition="top"
              (click)="abrirTitulosDoCliente(despesa)"
              (keydown.enter)="abrirTitulosDoCliente(despesa)">
            <td>{{ despesa.valor | moedaSimbolo: moedaConfig.symbol : moedaConfig.digits : moedaConfig.locale }}</td>
            <td>{{ despesa.dataPagamento | date: 'dd/MM/yyyy' }}</td>
            <td>
              <!-- O backend serializa TipoDespesa como { enum, nome, cor, icone, ... };
                   por legado o campo pode vir como string crua (sem cor/icone) e
                   nesse caso a linha mostra apenas o nome. -->
              <div class="flex align-items-center gap-2">
                <div *ngIf="despesa.tipoDespesa?.icone || despesa.tipoDespesa?.cor"
                  class="flex align-items-center justify-content-center border-circle"
                  [ngStyle]="{ width: '28px', height: '28px', 'min-width': '28px', background: despesa.tipoDespesa?.cor || '#eceff4' }">
                  <i class="{{ despesa.tipoDespesa?.icone || 'pi pi-briefcase' }}" style="color: #fff; font-size: 0.75rem;"></i>
                </div>
                <span>{{ tipoDespesaNome(despesa.tipoDespesa) }}</span>
              </div>
            </td>
            <!-- Gasto especial: o contador NAO adiantou o valor, entao a aprovacao nao gera
                 titulo a receber nem movimento no caixa dele. Mesmo formato do historico do
                 cliente (notificacoes-contador.component.html): icone + alternativa textual
                 sr-only, para as duas telas nao divergirem. -->
            <td class="text-center">
              <i class="pi"
                 aria-hidden="true"
                 [class.pi-check-circle]="despesa.especial"
                 [class.pi-minus]="!despesa.especial"
                 [class.especial-sim]="despesa.especial"></i>
              <span class="sr-only">
                {{ (despesa.especial ? 'common.sim' : 'common.nao') | translate }}
              </span>
            </td>
            <td>
              <p-tag [value]="statusLabel(despesa.status)" [severity]="statusSeverity(despesa.status)"></p-tag>
            </td>
            <td>
              <p-tag *ngIf="mostrarTagPagamento(despesa); else semPagamento"
                [value]="pagamentoLabel(despesa)"
                [severity]="pagamentoSeverity(despesa)"
                [pTooltip]="pagamentoTooltip(despesa)"
                tooltipPosition="top">
              </p-tag>
              <ng-template #semPagamento><span class="acoes-vazio">–</span></ng-template>
            </td>
            <td class="col-acoes" (click)="$event.stopPropagation()">
              <div class="acoes-despesa" *ngIf="podeAlterar(despesa); else semAcoes">
                <button pButton
                  type="button"
                  icon="pi pi-pencil"
                  class="p-button-rounded p-button-text"
                  [pTooltip]="'contador_operar.despesa_acessoria.editar' | translate"
                  tooltipPosition="top"
                  [attr.aria-label]="'contador_operar.despesa_acessoria.editar' | translate"
                  (click)="editar(despesa)">
                </button>
                <button pButton
                  type="button"
                  icon="pi pi-trash"
                  severity="danger"
                  class="p-button-rounded p-button-text"
                  [pTooltip]="'contador_operar.despesa_acessoria.excluir' | translate"
                  tooltipPosition="top"
                  [attr.aria-label]="'contador_operar.despesa_acessoria.excluir' | translate"
                  (click)="excluir(despesa)">
                </button>
              </div>
              <ng-template #semAcoes>
                <span class="acoes-vazio">-</span>
              </ng-template>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="7">
              <div class="estado-vazio">
                <i class="pi pi-inbox"></i>
                <p>{{ 'contador_operar.despesa_acessoria.lista_vazia' | translate }}</p>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <!-- Paginacao server-side (paginador separado, mesmo padrao de Indicacoes/cupons) -->
      <div class="pagination-container" *ngIf="totalRecords > 0">
        <div>
          <p-paginator (onPageChange)="onPageChange($any($event))"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="{first} - {last} de {totalRecords}"
            [first]="first" [rows]="rows"
            [totalRecords]="totalRecords" [showFirstLastIcon]="true">
          </p-paginator>
        </div>
        <div class="flex align-items-center">
          <span class="mx-1 text-color">{{ 'contador_operar.despesa_acessoria.itens_por_pagina' | translate }}</span>
          <p-dropdown [options]="pageSizeOptions" optionLabel="label"
            optionValue="value" [(ngModel)]="rows"
            (ngModelChange)="onRowsPerPageChange()" appendTo="body" styleClass="w-6rem">
          </p-dropdown>
        </div>
      </div>
      </ng-container>
    </div>
  </div>

</ng-container>

<!-- =================================================================== -->
<!-- Diálogo de confirmação de exclusão (padrão dialog-wave — danger)     -->
<!-- =================================================================== -->
<p-dialog
  [(visible)]="excluirDialogVisivel"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign dialog-footer-end"
  [style]="{ width: '32rem' }"
  [breakpoints]="{ '640px': '95vw' }"
  (onHide)="fecharDialogExcluir()">

  <div class="dialog-wave-header dialog-wave-header--danger">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-trash" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'contador_operar.despesa_acessoria.excluir_titulo' | translate }}</h2>
        <p class="dialog-wave-subtitle" *ngIf="despesaParaExcluir">
          {{ tipoDespesaNome(despesaParaExcluir.tipoDespesa) }} —
          {{ despesaParaExcluir.valor | moedaSimbolo: moedaConfig.symbol : moedaConfig.digits : moedaConfig.locale }}
        </p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <p>{{ 'contador_operar.despesa_acessoria.confirmar_exclusao' | translate }}</p>
    <!-- Despesa já efetivada: excluir cancela os títulos dos dois lados. A ressalva do ajuste
         manual do caixa só aparece quando o backend NÃO estorna sozinho — despesa especial (sem
         adiantamento) ou anterior à V1.106 (sem vínculo com o movimento). -->
    <div class="cancelar-aviso-futuro" *ngIf="despesaParaExcluir && despesaParaExcluir.status === 'ATIVA'">
      <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
      <span>
        {{ 'contador_operar.despesa_acessoria.aviso_ativa_exclusao' | translate }}
        <ng-container *ngIf="!despesaParaExcluir.especial && !despesaParaExcluir.ajustaCaixaAutomaticamente">
          {{ 'contador_operar.despesa_acessoria.aviso_ativa_movimento' | translate }}
        </ng-container>
      </span>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton
      [label]="'contador_operar.despesa_acessoria.cancelar' | translate"
      class="p-button-secondary"
      [disabled]="excluindo"
      (click)="fecharDialogExcluir()">
    </button>
    <button pButton
      [label]="'contador_operar.despesa_acessoria.excluir' | translate"
      icon="pi pi-trash"
      severity="danger"
      style="gap: 0.35rem"
      [disabled]="excluindo"
      [loading]="excluindo"
      (click)="confirmarExclusao()">
    </button>
  </ng-template>
</p-dialog>

<!-- =================================================================== -->
<!-- Diálogo de cancelamento do CONTRATO (padrão dialog-wave — danger)   -->
<!-- =================================================================== -->
<p-dialog
  [(visible)]="cancelarContratoDialogVisivel"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign dialog-footer-end"
  [style]="{ width: '34rem' }"
  [breakpoints]="{ '640px': '95vw' }"
  (onHide)="fecharCancelarContrato()">

  <div class="dialog-wave-header dialog-wave-header--danger">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-times-circle" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'contador_operar.despesa_acessoria.cancelar_contrato.titulo' | translate }}</h2>
        <p class="dialog-wave-subtitle" *ngIf="contrato">
          {{ contrato.nomeEmpresa }}
        </p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <p>{{ 'contador_operar.despesa_acessoria.cancelar_contrato.confirmar' | translate }}</p>

    <div class="form-field" style="margin-top: 1rem">
      <label class="form-label" for="dataCancelamento">
        {{ 'contador_operar.despesa_acessoria.cancelar_contrato.data_label' | translate }}
      </label>
      <p-calendar
        inputId="dataCancelamento"
        [(ngModel)]="cancelarContratoData"
        dateFormat="dd/mm/yy"
        [showIcon]="true"
        [minDate]="dataMinimaCancelamento"
        [readonlyInput]="true"
        appendTo="body"
        styleClass="w-full"
        [style]="{ width: '100%' }"
        [inputStyle]="{ width: '100%' }">
      </p-calendar>
      <small class="form-ajuda">
        {{ 'contador_operar.despesa_acessoria.cancelar_contrato.data_ajuda' | translate }}
      </small>
    </div>

    <!-- Aviso explícito quando a data escolhida é futura: o contrato é cancelado
         AGORA (status Cancelado); a data só adia o corte das cobranças. -->
    <div class="cancelar-aviso-futuro" *ngIf="cancelamentoFuturo">
      <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
      <span>
        {{ 'contador_operar.despesa_acessoria.cancelar_contrato.aviso_futuro'
          | translate: { data: (cancelarContratoData | date: 'dd/MM/yyyy') } }}
      </span>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton
      [label]="'contador_operar.despesa_acessoria.cancelar' | translate"
      class="p-button-secondary"
      [disabled]="cancelandoContrato"
      (click)="fecharCancelarContrato()">
    </button>
    <button pButton
      [label]="'contador_operar.despesa_acessoria.cancelar_contrato.confirmar_botao' | translate"
      icon="pi pi-times-circle"
      severity="danger"
      style="gap: 0.35rem"
      [disabled]="cancelandoContrato"
      [loading]="cancelandoContrato"
      (click)="confirmarCancelarContrato()">
    </button>
  </ng-template>
</p-dialog>

<!-- =============== Dialog: Adicionar parcelas =============== -->
<p-dialog
  [(visible)]="adicionarParcelasDialogVisivel"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign dialog-footer-end"
  [style]="{ width: '34rem' }"
  [breakpoints]="{ '640px': '95vw' }"
  (onHide)="fecharAdicionarParcelas()">

  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-plus" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'contador_operar.despesa_acessoria.parcelas.adicionar_titulo' | translate }}</h2>
        <p class="dialog-wave-subtitle">{{ 'contador_operar.despesa_acessoria.parcelas.adicionar_subtitulo' | translate }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <div class="p-fluid formgrid grid adicionar-parcelas-form inputnumber-stepper-compacto">
      <!-- Linha 1: Quantidade + Parcelas por mes (2 colunas) -->
      <div class="field col-12 md:col-6">
        <label>{{ 'contador_operar.despesa_acessoria.parcelas.adicionar_quantidade' | translate }} <span class="obrigatorio">*</span></label>
        <p-inputNumber
          [(ngModel)]="novaQuantidadeParcelas"
          [min]="1"
          [showButtons]="true"
          [step]="1"
          [useGrouping]="false"
          styleClass="w-full"
          [class.error-field]="adicionarParcelasSubmetido && (novaQuantidadeParcelas == null || novaQuantidadeParcelas < 1)">
        </p-inputNumber>
      </div>

      <div class="field col-12 md:col-6">
        <label>{{ 'contador_operar.despesa_acessoria.parcelas.adicionar_periodicidade' | translate }} <span class="obrigatorio">*</span></label>
        <p-inputNumber
          [(ngModel)]="novaPeriodicidadeParcelas"
          [min]="1"
          [showButtons]="true"
          [step]="1"
          [useGrouping]="false"
          styleClass="w-full"
          [class.error-field]="adicionarParcelasSubmetido && (novaPeriodicidadeParcelas == null || novaPeriodicidadeParcelas < 1)">
        </p-inputNumber>
        <small class="block mt-1 text-color-secondary">{{ 'contador_operar.despesa_acessoria.parcelas.adicionar_periodicidade_ajuda' | translate }}</small>
      </div>

      <!-- Linha 2: Data do primeiro vencimento (opcional, largura total) -->
      <div class="field col-12">
        <label>{{ 'contador_operar.despesa_acessoria.parcelas.adicionar_data_primeiro_vencimento' | translate }}</label>
        <p-calendar
          [(ngModel)]="novaDataPrimeiroVencimento"
          dateFormat="dd/mm/yy"
          [readonlyInput]="true"
          [showButtonBar]="true"
          appendTo="body"
          styleClass="w-full"
          [placeholder]="'contador_operar.despesa_acessoria.parcelas.adicionar_data_placeholder' | translate">
        </p-calendar>
        <small class="block mt-1 text-color-secondary">{{ 'contador_operar.despesa_acessoria.parcelas.adicionar_data_ajuda' | translate }}</small>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton
      [label]="'contador_operar.despesa_acessoria.cancelar' | translate"
      class="p-button-secondary"
      [disabled]="adicionandoParcelas"
      (click)="fecharAdicionarParcelas()">
    </button>
    <button pButton
      [label]="'contador_operar.despesa_acessoria.parcelas.adicionar_confirmar' | translate"
      icon="pi pi-check"
      style="gap: 0.35rem"
      [disabled]="adicionandoParcelas || !adicionarParcelasValido"
      [loading]="adicionandoParcelas"
      (click)="confirmarAdicionarParcelas()">
    </button>
  </ng-template>
</p-dialog>

<!-- =============== Dialog: Faturar parcelas =============== -->
<p-dialog
  [(visible)]="faturarDialogVisivel"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign dialog-footer-end"
  [style]="{ width: '36rem' }"
  [breakpoints]="{ '640px': '95vw' }"
  (onHide)="fecharFaturar()">

  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-file-edit" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'contador_operar.despesa_acessoria.parcelas.faturar_titulo' | translate }}</h2>
        <p class="dialog-wave-subtitle">{{ 'contador_operar.despesa_acessoria.parcelas.faturar_subtitulo' | translate }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body faturar-body" *ngIf="prepFaturamento as prep">
    <!-- Resumo da venda a ser criada -->
    <div class="faturar-resumo">
      <div class="faturar-linha">
        <span class="faturar-label">{{ 'contador_operar.despesa_acessoria.parcelas.faturar_cliente' | translate }}</span>
        <span class="faturar-valor">{{ prep.pessoaNome }}</span>
      </div>
      <div class="faturar-linha">
        <span class="faturar-label">{{ 'contador_operar.despesa_acessoria.parcelas.faturar_periodo' | translate }}</span>
        <span class="faturar-valor">{{ prep.descricaoServico }}</span>
      </div>
      <div class="faturar-linha">
        <span class="faturar-label">{{ 'contador_operar.despesa_acessoria.parcelas.faturar_servico' | translate }}</span>
        <span class="faturar-valor">{{ prep.itemServicoNome }}</span>
      </div>
      <div class="faturar-linha" *ngIf="vendedorNome">
        <span class="faturar-label">{{ 'contador_operar.despesa_acessoria.parcelas.faturar_vendedor' | translate }}</span>
        <span class="faturar-valor">{{ vendedorNome }}</span>
      </div>
      <div class="faturar-linha">
        <span class="faturar-label">{{ 'contador_operar.despesa_acessoria.parcelas.faturar_valor' | translate }}</span>
        <span class="faturar-valor faturar-total">
          {{ prep.valorTotal | moedaSimbolo: moedaConfig.symbol : moedaConfig.digits : moedaConfig.locale }}
        </span>
      </div>
    </div>

    <!-- Forma de pagamento -->
    <div class="field">
      <label>{{ 'contador_operar.despesa_acessoria.parcelas.faturar_forma_pagamento' | translate }}</label>
      <p-selectButton
        [options]="formaPagamentoFaturarOptions"
        optionLabel="label"
        optionValue="value"
        [(ngModel)]="formaPagamentoFaturar"
        [allowEmpty]="false">
      </p-selectButton>
    </div>

    <!-- Juros (opcional): parcelas atrasadas -->
    <div class="field">
      <div class="form-item form-item-checkbox">
        <p-checkbox
          [(ngModel)]="adicionarJuros"
          name="adicionarJuros"
          [binary]="true"
          inputId="faturarAdicionarJuros"
          [disabled]="processandoFaturamento"
          (onChange)="onToggleJuros()">
        </p-checkbox>
        <label for="faturarAdicionarJuros" class="checkbox-label">
          {{ 'contador_operar.despesa_acessoria.parcelas.faturar_juros_adicionar' | translate }}
        </label>
      </div>

      <div class="faturar-juros" *ngIf="adicionarJuros">
        <label for="faturarPercentualJuros">
          {{ 'contador_operar.despesa_acessoria.parcelas.faturar_juros_percentual' | translate }}
        </label>
        <div class="p-inputgroup faturar-juros-input">
          <input
            pInputText
            id="faturarPercentualJuros"
            type="number"
            min="0"
            step="0.01"
            inputmode="decimal"
            [(ngModel)]="percentualJuros"
            [disabled]="processandoFaturamento || recalculandoJuros"
            (blur)="onPercentualJurosChange()"
            placeholder="0,00" />
          <span class="p-inputgroup-addon">% / {{ 'contador_operar.despesa_acessoria.parcelas.faturar_juros_mes' | translate }}</span>
        </div>
        <small class="form-ajuda">{{ 'contador_operar.despesa_acessoria.parcelas.faturar_juros_ajuda' | translate }}</small>

        <div class="faturar-linha" *ngIf="prep.jurosTotal > 0">
          <span class="faturar-label">
            {{ 'contador_operar.despesa_acessoria.parcelas.faturar_juros_valor' | translate }}
            <ng-container *ngIf="prep.quantidadeParcelasComJuros as q">({{ q }})</ng-container>
          </span>
          <span class="faturar-valor">
            {{ prep.jurosTotal | moedaSimbolo: moedaConfig.symbol : moedaConfig.digits : moedaConfig.locale }}
          </span>
        </div>
        <small
          class="form-ajuda faturar-juros-aviso"
          *ngIf="percentualJuros && !recalculandoJuros && prep.jurosTotal === 0">
          {{ 'contador_operar.despesa_acessoria.parcelas.faturar_juros_sem_atraso' | translate }}
        </small>
      </div>
    </div>

    <!-- Total com juros -->
    <div class="faturar-linha faturar-linha-total" *ngIf="prep.jurosTotal > 0">
      <span class="faturar-label">{{ 'contador_operar.despesa_acessoria.parcelas.faturar_total_com_juros' | translate }}</span>
      <span class="faturar-valor faturar-total">
        {{ (prep.valorTotal + prep.jurosTotal) | moedaSimbolo: moedaConfig.symbol : moedaConfig.digits : moedaConfig.locale }}
      </span>
    </div>

    <!-- Vencimento (somente a prazo) -->
    <div class="field" *ngIf="formaPagamentoFaturar === 'prazo'">
      <label>{{ 'contador_operar.despesa_acessoria.parcelas.faturar_vencimento' | translate }}</label>
      <span class="faturar-vencimento">{{ prep.vencimentoPrimeiraParcela | date: 'dd/MM/yyyy' }}</span>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton
      [label]="'contador_operar.despesa_acessoria.cancelar' | translate"
      class="p-button-secondary"
      [disabled]="processandoFaturamento"
      (click)="fecharFaturar()">
    </button>
    <button pButton
      [label]="'contador_operar.despesa_acessoria.parcelas.faturar_confirmar' | translate"
      icon="pi pi-check"
      style="gap: 0.35rem"
      [disabled]="processandoFaturamento"
      [loading]="processandoFaturamento"
      (click)="confirmarFaturamento()">
    </button>
  </ng-template>
</p-dialog>

<!-- =============== Dialog: Excluir parcelas (padrão dialog-wave — danger) =============== -->
<p-dialog
  [(visible)]="excluirParcelasDialogVisivel"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign dialog-footer-end"
  [style]="{ width: '32rem' }"
  [breakpoints]="{ '640px': '95vw' }"
  (onHide)="fecharExcluirParcelas()">

  <div class="dialog-wave-header dialog-wave-header--danger">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-trash" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'contador_operar.despesa_acessoria.parcelas.excluir_titulo' | translate }}</h2>
        <p class="dialog-wave-subtitle">
          {{ 'contador_operar.despesa_acessoria.parcelas.selecionadas' | translate: { count: parcelasSelecionadas.length } }}
        </p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <p>{{ 'contador_operar.despesa_acessoria.parcelas.excluir_confirmacao' | translate: { count: parcelasSelecionadas.length } }}</p>
  </div>

  <ng-template pTemplate="footer">
    <button pButton
      [label]="'contador_operar.despesa_acessoria.cancelar' | translate"
      class="p-button-secondary"
      [disabled]="excluindoParcelas"
      (click)="fecharExcluirParcelas()">
    </button>
    <button pButton
      [label]="'contador_operar.despesa_acessoria.parcelas.excluir_confirmar' | translate"
      icon="pi pi-trash"
      severity="danger"
      style="gap: 0.35rem"
      [disabled]="excluindoParcelas"
      [loading]="excluindoParcelas"
      (click)="confirmarExcluirParcelasLote()">
    </button>
  </ng-template>
</p-dialog>

<!-- =============== Dialog: Confirmar mês de referência (padrão dialog-wave — info) =============== -->
<!-- Fechar sem confirmar (Cancelar / ESC / clique fora) reverte o dropdown
     (onMesReferenciaHide); Confirmar dispara o PATCH.
     closable=true habilita o ESC (o PrimeNG só liga o closeOnEscape quando
     closable=true); como showHeader=false, o "X" NÃO é renderizado — logo,
     ganhamos ESC sem alterar o visual do diálogo. -->
<p-dialog
  [(visible)]="mesReferenciaDialogVisivel"
  [showHeader]="false"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  styleClass="dialog-wave-redesign dialog-footer-end"
  [style]="{ width: '32rem' }"
  [breakpoints]="{ '640px': '95vw' }"
  (onHide)="onMesReferenciaHide()">

  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-calendar" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'contador_operar.despesa_acessoria.contrato.mes_referencia' | translate }}</h2>
        <p class="dialog-wave-subtitle">{{ mesReferenciaLabel(mesReferenciaNovo) }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <p>{{ 'contador_operar.despesa_acessoria.contrato.mes_referencia_confirmacao' | translate }}</p>
  </div>

  <ng-template pTemplate="footer">
    <button pButton
      [label]="'contador_operar.despesa_acessoria.cancelar' | translate"
      class="p-button-secondary"
      [disabled]="salvandoMesReferencia"
      (click)="fecharMesReferencia()">
    </button>
    <button pButton
      [label]="'contador_operar.despesa_acessoria.contrato.mes_referencia_confirmar' | translate"
      icon="pi pi-check"
      class="btn-primary"
      style="gap: 0.35rem"
      [disabled]="salvandoMesReferencia"
      (click)="confirmarMesReferencia()">
    </button>
  </ng-template>
</p-dialog>

<!-- =============== Dialog: Confirmar edição do contrato (valor mensal / dia de cobrança) =============== -->
<p-dialog
  [(visible)]="confirmarEdicaoVisivel"
  [showHeader]="false"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  styleClass="dialog-wave-redesign dialog-footer-end"
  [style]="{ width: '34rem' }"
  [breakpoints]="{ '640px': '95vw' }"
  (onHide)="cancelarEdicaoContrato()">

  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-pencil" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ (edicaoCampo === 'valor'
              ? 'contador_operar.despesa_acessoria.contrato.valor_mensal'
              : edicaoCampo === 'dia'
                ? 'contador_operar.despesa_acessoria.contrato.dia_cobranca'
                : 'contador_operar.despesa_acessoria.contrato.parcelas_por_mes') | translate }}</h2>
        <p class="dialog-wave-subtitle" *ngIf="contrato">{{ contrato.nomeEmpresa }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <!-- De -> Para -->
    <div class="edicao-de-para" *ngIf="edicaoCampo === 'valor'">
      <span class="edicao-atual">
        {{ contrato?.valorMensal | moedaSimbolo: moedaConfig.symbol : moedaConfig.digits : moedaConfig.locale }}
      </span>
      <i class="pi pi-arrow-right" aria-hidden="true"></i>
      <span class="edicao-novo">
        {{ edicaoValorPendente | moedaSimbolo: moedaConfig.symbol : moedaConfig.digits : moedaConfig.locale }}
      </span>
    </div>
    <div class="edicao-de-para" *ngIf="edicaoCampo === 'dia'">
      <span class="edicao-atual">{{ contrato?.diaCobranca }}</span>
      <i class="pi pi-arrow-right" aria-hidden="true"></i>
      <span class="edicao-novo">{{ edicaoValorPendente }}</span>
    </div>
    <div class="edicao-de-para" *ngIf="edicaoCampo === 'parcelasPorMes'">
      <span class="edicao-atual">{{ contrato?.parcelasPorMes }}</span>
      <i class="pi pi-arrow-right" aria-hidden="true"></i>
      <span class="edicao-novo">{{ edicaoValorPendente }}</span>
    </div>

    <p>{{ (edicaoCampo === 'parcelasPorMes'
        ? 'contador_operar.despesa_acessoria.editar_contrato.confirmacao_parcelas_por_mes'
        : 'contador_operar.despesa_acessoria.editar_contrato.confirmacao') | translate }}</p>
  </div>

  <ng-template pTemplate="footer">
    <button pButton
      [label]="'contador_operar.despesa_acessoria.cancelar' | translate"
      class="p-button-secondary"
      [disabled]="salvandoEdicaoContrato"
      (click)="cancelarEdicaoContrato()">
    </button>
    <button pButton
      [label]="'contador_operar.despesa_acessoria.editar_contrato.confirmar_botao' | translate"
      icon="pi pi-check"
      class="btn-primary"
      style="gap: 0.35rem"
      [disabled]="salvandoEdicaoContrato"
      [loading]="salvandoEdicaoContrato"
      (click)="confirmarEdicaoContrato()">
    </button>
  </ng-template>
</p-dialog>
